import { LanguagesIsoEnum } from "@/modules/assessments/types/test.interface";
import { DEFAULT_LOCALE } from "./types";
import enUSMessages from "./messages/en-US.json";

type Messages = Record<string, string>;

const messageCache: Partial<Record<LanguagesIsoEnum, Messages>> = {
  [LanguagesIsoEnum.enUS]: enUSMessages,
};

// en-US ships in the main bundle; other locales are lazy-loaded on demand.
export async function loadMessages(locale: LanguagesIsoEnum): Promise<Messages> {
  const cached = messageCache[locale];
  if (cached) return cached;

  switch (locale) {
    case LanguagesIsoEnum.esUS: {
      const messages = (await import("./messages/es-US.json")).default;
      messageCache[locale] = messages;
      return messages;
    }
    default:
      // Unknown locale: serve en-US but don't cache it under `locale` — caching would make
      // isMessagesCached report true and pin callers to en-US even after the real bundle exists.
      return enUSMessages;
  }
}

// Synchronous read for already-cached locales; falls back to en-US otherwise.
export function getMessagesSync(locale: LanguagesIsoEnum): Messages {
  return messageCache[locale] ?? messageCache[DEFAULT_LOCALE]!;
}

// Whether the locale's bundle is already in memory (so getMessagesSync returns it rather than the
// en-US fallback). Lets callers avoid painting a non-default locale over fallback strings before the
// async load resolves.
export function isMessagesCached(locale: LanguagesIsoEnum): boolean {
  return Boolean(messageCache[locale]);
}
